<template>
  <v-card flat>
    <v-container class="ma-0 mp-0">
      <v-row no-gutters>
        <v-col cols="1" offset="1">
          <v-subheader>Start Date</v-subheader>
        </v-col>
        <v-col cols="3">
          <ymd-datepicker
            v-model="startDate"
            label="Start Date"
            required
            :rules="vruleFieldRequired"
            hint="*Required"
            persistent-hint
          ></ymd-datepicker>
        </v-col>
        <v-col cols="3" offset="1">
          <template v-if="numberOfDays">
            <h1 class="offset-header green--text">{{ numberOfDays }}</h1>
            <v-subheader>Number of days in report</v-subheader>
          </template>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="1" offset="1">
          <v-subheader>End Date</v-subheader>
        </v-col>
        <v-col cols="3">
          <ymd-datepicker
            v-model="endDate"
            label="End Date"
            required
            :rules="vruleFieldRequired"
            hint="*Required"
            persistent-hint
          ></ymd-datepicker>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { YMDDatePicker } from '@/components/inputs'
import validationMixin from '@/validators/validations_mixin'
import { hasValue } from '@/utils'
import { DateTime } from 'luxon'

export default {
  name: 'report-start-end-input',
  displayName: 'By Timeframe',
  title: 'Select the Timeframe to generate a report',
  mixins: [validationMixin],
  components: {
    [YMDDatePicker.name]: YMDDatePicker
  },

  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      startDate: null,
      endDate: null,
      numberOfDays: null
    }
  },
  computed: {
  },
  watch: {
    startDate: function () {
      this.updateState()
    },
    endDate: function () {
      this.updateState()
    }
  },
  methods: {
    mdyDate (dateObj) {
      return dateObj.toISODate()
    },
    updateState () {
      if (hasValue(this.startDate) && hasValue(this.endDate)) {
        this.numberOfDays = DateTime.fromISO(this.endDate).diff(DateTime.fromISO(this.startDate), 'days').toObject().days
        this.$emit('input', { startDate: this.startDate, endDate: this.endDate })
      } else {
        alert('no go')
      }
    },
    setDefaultTimeframe () {
      this.endDate = this.mdyDate(DateTime.now())
      this.startDate = this.mdyDate(DateTime.now().minus({ days: 45 }))
    }
  },
  mounted () {
    this.setDefaultTimeframe()
  }
}
</script>

<style scoped>
  .offset-header {
    padding: 0 16px 0 16px
  }
</style>
